import { transformCurrencyAmountDto } from '@marketplace-web/currency/currency-data'

import { UserStatsDto, UserStatsModel } from '../types/user-stats'

export const transformUserStatsDto = (userStats: UserStatsDto): UserStatsModel => ({
  unreadMsgCount: userStats.unread_msg_count,
  unreadNotificationCount: userStats.unread_notification_count,
  itemCount: userStats.item_count,
  walletBalance: transformCurrencyAmountDto(userStats.wallet_balance),
})
